import React from "react";
import Header from "../components/Header";
import {
  HeroImg,
  HomePageSectionBottom,
  HomePageSectionTop,
} from "../components/HomepageComp";
import Footer from "../components/Footer";

const Homepage = () => {
  return (
    <>
      <Header />
      <HeroImg />
      <HomePageSectionTop />
      <HomePageSectionBottom />
      <Footer />
    </>
  );
};

export default Homepage;
